import {
  CreateResourceFavoriteInput,
  DeleteResourceFavoriteInput,
} from "@examspark/types";

import { GraphQLAPI } from "../client";

export const createFavorite = async (variables: {
  input: CreateResourceFavoriteInput;
}) => {
  const rsp = await GraphQLAPI.client.query<{
    createResourceFavorite: any;
  }>({
    query: /* GraphQL */ `
      mutation CreateResourceFavorite($input: CreateResourceFavoriteInput!) {
        createResourceFavorite(input: $input) {
          id
          sk
          createdAt
          updatedAt
        }
      }
    `,
    variables,
  });

  return rsp;
};

export const deleteFavorite = async (variables: {
  input: DeleteResourceFavoriteInput;
}) => {
  const rsp = await GraphQLAPI.client.query<{
    deleteResourceFavorite: any;
  }>({
    query: /* GraphQL */ `
      mutation DeleteResourceFavorite($input: DeleteResourceFavoriteInput!) {
        deleteResourceFavorite(input: $input) {
          id
          sk
          createdAt
          updatedAt
        }
      }
    `,
    variables,
  });

  return rsp;
};
